import { UploadFileError } from "@redotech/redo-model/upload-file";

export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        reject(new Error("Failed to read file"));
        return;
      }
      const base64 = result.split(",")[1];
      if (!base64) {
        reject(new Error("Failed to read file"));
        return;
      }
      resolve(base64);
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
}

export function extractFileNameFromUrl(
  url: URL | undefined,
): string | undefined {
  if (!url) {
    return undefined;
  }
  const segment = url.pathname.split("/").pop() ?? "";
  try {
    return decodeURIComponent(segment) || undefined;
  } catch {
    return segment || undefined;
  }
}

/**
 * Helper function to extract error messages from upload errors
 */
export function extractUploadErrorMessage(error: unknown): string {
  if (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    typeof error.response === "object" &&
    error.response !== null &&
    "data" in error.response &&
    typeof error.response.data === "object" &&
    error.response.data !== null &&
    "error" in error.response.data &&
    "errorMessage" in error.response.data &&
    typeof error.response.data.errorMessage === "string" &&
    error.response.data.error ===
      UploadFileError.FILE_SIZE_LARGER_THAN_TARGET_MAX_SIZE
  ) {
    return error.response.data.errorMessage;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Something went wrong uploading the file. Please try again.";
}
